const jQ = jQuery.noConflict();

class SetActive {
    constructor(sel) {
        this.selector = sel;
    }
    toggleActive(e) {
        e.preventDefault();
        if(jQ('.summary.entry-summary').length){
            jQ('.summary.entry-summary').height('');
        }

        if (!jQ(this).hasClass('active')) {
            jQ(this).next().slideDown(300, 'linear');
            jQ(this).addClass('active');
        } else {
            jQ(this).next().slideUp(300, 'linear');
            jQ(this).removeClass('active');
        }
    }
    init() {
        jQ(this.selector).on('click', this.toggleActive);
    }
}

export default SetActive;
